<template>
  <el-dialog title :show-close="false" :visible.sync="value.filtersVisible" width="40%">
    <template v-slot:title>
      <h3>Update Additional Questions Saleable Items</h3>
    </template>
    <template>
      <el-form ref="form" :model="regoQsAnswers" :rules="rules" label-position="top" :key="key" style="width">
      <el-row >
        <el-col :span="24" :xs="20" :lg="20" :md="20"  v-for="q in additionalQs" :key="q._id">
          <!-- Input -->
          <div  v-if="q.type === 1 && checkVisibility(q)">
            <el-input-title :required="q.required"><span v-html="urlify(q.question)"></span></el-input-title>
            <el-form-item :prop="q.metaField | metaProp">
              <el-input  v-model="regoQsAnswers[q.metaField]" placeholder="Type here..."/>
            </el-form-item>
          </div>
          <div class="mt-2" v-if="q.type === 2 && checkVisibility(q)">
            <!-- Dropdown -->
            <el-input-title :required="q.required">{{ checkIfParent(q._id) ? 'Parent Question Level 1: ' : '' }}<span v-html="urlify(q.question)"></span></el-input-title>
            <el-form-item :prop="q.metaField | metaProp">
              <el-select class="w-100 " v-model="regoQsAnswers[q.metaField]" placeholder="Select" clearable @change="updateChildValues(q)">
                <el-option
                  v-for="{ value } in q.meta.options"
                  :key="value"
                  :label="value"
                  :value="value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="q.isParentQs && q.parentsDependentQsList">
            <el-col :span="24" v-for="c in q.parentsDependentQsList[0].children" :key="c._id">
              <div class="mt-05" v-if="checkChildVisibility(c, q.parentsDependentQsList[0])">
                <!-- Input -->
                <div v-if="c.type === 1">
                  <el-input-title :required="c.required"><span v-html="urlify(c.question)"></span></el-input-title>
                  <el-form-item :prop="'meta.' + camelCase(c.fieldName)">
                    <el-input class="mt-05" v-model="registration.meta[camelCase(c.fieldName)]" placeholder="Type here..."/>
                  </el-form-item>
                </div>

                <!-- Dropdown -->
                <div v-else-if="c.type === 2">
                  <el-input-title :required="c.required"><span v-html="urlify(c.question)"></span></el-input-title>
                  <el-form-item :prop="'meta.' + camelCase(c.fieldName)">
                    <el-select class="w-100 mt-05" v-model="registration.meta[camelCase(c.fieldName)]" placeholder="Select" clearable :multiple="c.multiDropdownSelect">
                      <el-option
                        v-for="({ value }, i) in c.meta.options"
                        :key="value"
                        :label="value"
                        :value="value"
                      >
                        {{ value }}
                        <el-dropdown @click.native.stop v-if="c.meta.descriptions && c.meta.descriptions[i].value">
                          <span class="el-dropdown-link">
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-alert
                              title="Description"
                              type="info"
                              :closable="false"
                              effect="dark">
                              {{ c.meta.descriptions[i].value }}
                            </el-alert>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <!-- File Upload -->
                <div v-else-if="c.type === 3">
                  <el-input-title :required="c.required">{{ c.question || 'Your entity requires a file to be uploaded' }}</el-input-title>
                  <h5 class="mt-05"><i class="el-icon-info"></i> Files must be 10mb or less</h5>
                  <el-upload
                    :headers="uploadHeaders"
                    :accept="accept"
                    :limit="3"
                    :file-list="registration.meta[camelCase(c.fieldName)].map(file => ({ name: file.originalName }))"
                    :before-upload="(file) => beforeUpload(file, c)"
                    :on-error="onError"
                    :on-remove="onRemove"
                    action=""
                    :on-change="(file) => handleChange(file, c)"
                    :auto-upload="false"
                    :on-exceed="onExceed"
                  >
                    <el-button class="mt-0" size="medium" type="secondary">Click to upload</el-button>
                  </el-upload>
                </div>

                <!-- NSWISA PPC Form -->
                <div v-else-if="c.type === 1001">
                  <PPCForm :formItemProp="'meta.' + camelCase(c.fieldName)" v-model="registration.meta[camelCase(c.fieldName)]"/>
                </div>
              </div>
            </el-col>
          </div>
          <div class="mt-2" v-if="q.type === 3 && checkVisibility(q)">
            <!-- File Upload -->
            <el-input-title :required="q.required">{{ q.question || 'Your entity requires a file to be uploaded' }}</el-input-title>
            <h5 class="mt-2"><i class="el-icon-info"></i> Files must be 10mb or less</h5>
            <el-upload
              class="file-name"
              :headers="uploadHeaders"
              :accept="accept"
              :limit="get(q, 'meta.fileLimit', 1)"
              :file-list="getFileList(q)"
              :before-upload="(file) => beforeUpload(file, q)"
              :on-error="onError"
              :before-remove="beforeRemoveAQ"
              :on-remove="onRemoveAQ"
              action=""
              :on-change="(file) => handleChangeAQ(file, q)"
              :auto-upload="false"
              :on-exceed="onExceed"
              :disabled="getUploadExpiry()"
            >
              <el-button class="mt-0" size="medium" type="secondary">Click to upload </el-button>
            </el-upload>
          </div>
          <!------- National Special Types ------>
          <div class="mt-2" v-if="q.type === 1001 && checkVisibility(q)">
            <!-- NSWISA PPC Form -->
            <PPCForm :formItemProp="q.metaField | metaProp" v-model="regoQsAnswers[q.metaField]"/>
          </div>
        </el-col>
      </el-row>
    </el-form>
    </template>
    <template v-slot:footer>
      <el-button @click="clearAnswer">Cancel</el-button>
      <el-button type="primary" @click="saveAnswer" >Save</el-button>
    </template>
  </el-dialog>
</template>
<script>
import _ from 'lodash';
import moment from 'moment-timezone';

import { urlify } from '@/utils/helpers';

import {
  errormsg,
} from '@/utils/constants';
import aqsFileUploadMixin from '@/mixins/aqs-file-upload';
// eslint-disable-next-line import/no-unresolved
import PPCForm from './PPCForm.vue';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.input_option };

export default {
  props: {
    value: {
      type: Object,
    },
    entity: {
      type: String,
    },
    registration: {
      type: Object,
    },
    eventData: {
      type: Object,
    },
  },
  components: {
    PPCForm,
  },
  data() {
    return {
      get: _.get,
      camelCase: _.camelCase,
      key: 0,
      urlify,
      memberTypes: undefined,
      isType3: false,
      additionalQForm: {
        selectedMember: {
          name: undefined,
          detail: undefined
        },
        selectedQuestion: undefined,
      },
      regoQsAnswers: undefined,
      filesUploaded: [],
      additionalQuestion: {},
      selectedQuestions: [],
      event: {},
      additionalQs: [],
      rules: {

      },
      isUpdateQuestions: true,
    };
  },
  mixins: [aqsFileUploadMixin],
  mounted() {
    this.generateAQs(this.value);
  },
  methods: {
    getUploadExpiry() {
      console.log('value', this.value);
      console.log('eventData', this.eventData);
      const { entityType } = this.value.regoDetails;
      console.log({
        regoDetails: this.value.regoDetails,
      });
      if (entityType === 'event') {
        const [event] = this.value.regoDetails.event;
        const { regoEndDate, isActive } = event;
        if (moment().valueOf() <= regoEndDate && isActive) return false;
        console.log('isExpired', moment().valueOf() > regoEndDate);

        return true;
      }
      return false;
    },
    getFileList(q) {
      const filesUploaded = this.filesUploaded.filter((f) => f.meta.additionalQuestion === q.fieldName);
      return filesUploaded.map((file) => ({
        name: file.displayName ? `${file.displayName} (Uploaded At: ${this.dateFormatter(file.createdAt)})` : `${file.fileName} (Uploaded At: ${this.dateFormatter(file.createdAt)})`,
        url: file.path,
        registrationId: file.meta.registrationId,
        type: file.fileType,
        _id: file._id,
        createdAt: file.createdAt,
      }));
    },
    generateAQs(val) {
      console.log({
        val
      });
      // let filterAll;
      // const productType = _.get(val, 'registration.productType');
      // if (val.entityType === 'indv') {
      //   const { dob, gender } = val.registration.member.profile;
      //   const age = calculateMemberAge(dob, this.endOfYear);
      //   const filterAgeAndGender = (e) => age >= e.ageFrom && age <= e.ageTo && (e.gender === gender || e.gender === 'All' || !e.gender || (e.gender === 'Other' && (gender !== 'Male' || gender !== 'Female')));
      //   const { memberType } = val.registration;
      //   if (productType) filterAll = (e) => _.includes(e.productTypes, productType) && _.includes(e.memberTypes, memberType) && filterAgeAndGender(e);
      // } else if (productType) filterAll = (e) => _.includes(e.productTypes, productType);
      this.regoQsAnswers = _.cloneDeep(_.get(val, 'registration.meta'));
      this.filesUploaded = _.filter(_.cloneDeep(_.get(this, 'value.registration.files')), (f) => f.meta.additionalQuestion !== 'PPC Form');

      // this.$store.commit('loading', { loading: true, text: 'Loading...' });
      // this.$http.get(`assemble/api/v1/admin/events/${this.$route.params.id}/additional-questions`).then((response) => {
      // const entityType = _.get(val, 'registration.entityType', 'event');
      const { additionalQs } = val.registration;
      this.additionalQs = additionalQs;
      const hasMeta = !!this.regoQsAnswers;
      _.forEach(this.additionalQs, (q) => {
        const metaField = _.camelCase(q.fieldName);
        // eslint-disable-next-line
            q.metaField = metaField;
        // eslint-disable-next-line
            if (q.required) this.$set(this.rules, `${metaField}`, defaultRequiredRule);
        if (!hasMeta) {
          this.$set(
            this.regoQsAnswers,
            metaField,
            q.type === 3 ? [] : undefined // If it's a file upload initialize an array;
          );
        } else if (hasMeta) {
          if (q.type === 3) {
            this.$set(
              this.regoQsAnswers,
              metaField,
              this.regoQsAnswers[metaField] ? this.regoQsAnswers[metaField] : []
            );
          }
        }
      });
    },
    beforeRemoveAQ(file) {
      return this.$confirm(`Are you sure you want to remove ${ file.name } ?`, 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      });
    },
    onRemoveAQ(file) {
      if (!file.response && !file.name) return;
      // const { name } = file.response || file;
      const fileId = file._id;

      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.delete(`/assemble/api/v1/portal/files/${fileId}`)
        .then(() => {
          this.$store.commit('loading', false);
          this.$message.success('File deleted successfully');
          // filter out file from file list
          this.filesUploaded = this.filesUploaded.filter((f) => f._id !== fileId);
          this.$emit('updateFiles', { files: this.filesUploaded, regoId: this.value.registration._id });
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
          this.$store.commit('loading', false);
        });
    },
    async handleChangeAQ(file, q) {
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.error('File size is more than 10mb');
        return false;
      }
      // const fieldName = _.camelCase(q.fieldName);
      const {
        _id, entityId, entityType, productType
      } = this.value.registration;
      const { _id: memberId } = this.value.registration.member;
      try {
        this.$store.commit('loading', true);
        const fileType = file.raw.name.split('.')[file.raw.name.split('.').length - 1];
        const res = await this.$http.post('/assemble/api/v1/portal/files/get-presigned-url', {
          fileName: file.name,
          fileType,
          registrationId: _id,
          additionalQuestion: q.fieldName,
          entityId,
          entityType,
          memberId,
          productType: productType === 'team' ? 'team' : 'individual',
          type: 'additional-question',
        });
        const { url, fileId, insert } = res.data.data;
        await fetch(url, {
          method: 'PUT',
          body: file.raw,
          headers: { 'Content-Type': '*/*' },
        });
        // eslint-disable-next-line no-param-reassign
        file._id = fileId;
        // eslint-disable-next-line no-param-reassign
        file.name = `${file.name} (Uploaded At: ${this.dateFormatter(this.moment())})`;
        this.filesUploaded.push(insert);
        this.$emit('updateFiles', { files: this.filesUploaded, regoId: this.value.registration._id });
        // const uploads = _.get(this, `regoQsAnswers.${fieldName}`);
        // this.$set(this.regoQsAnswers, fieldName, uploads.concat({ fileName: name }));
      } catch (e) {
        this.$message.error('There has been an error');
      }
      return this.$store.commit('loading', false);
    },
    updateChildValues(q) {
      if (q.isParentQs && q.parentsDependentQsList) {
        _.forEach((q.parentsDependentQsList[0].children), (c) => {
          // eslint-disable-next-line no-unused-expressions
          this.regoQsAnswers[_.camelCase(c.fieldName)] = '';
        });
      }
    },
    checkIfParent(id) {
      const { additionalQs } = this;

      const find = (array = [], _id) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const question of array) {
          if (question.parentsDependentQsList) {
            // eslint-disable-next-line no-restricted-syntax
            for (const q of question.parentsDependentQsList) {
              if (q._id === _id) return true;
            }
          }
        }

        return false;
      };

      const found = find(additionalQs, id);
      if (found) return true;

      return false;
    },
    dateFormatter(timestamp) {
      return this.moment(timestamp).format('DD/MM/YYYY HH:mm');
    },
    showDisplayName(fileName) {
      const nameWithHash = fileName.split('.')[0].split('-');
      const displayName = nameWithHash.slice(0, nameWithHash.length - 1).join(' ');
      return displayName;
    },
    checkChildVisibility(question, parentQuestion) {
      const allQuestions = this.additionalQs;
      const allAnswers = this.regoQsAnswers;

      const childQuestion = allQuestions.find((qs) => qs._id === parentQuestion._id);
      if (childQuestion) {
        if (question.level === 2 && childQuestion) {
          const parentAnswer = allAnswers[childQuestion.metaField];
          return _.includes(parentQuestion.condition, parentAnswer);
        }
        const getLastQuestion = parentQuestion.children.find((p) => p.level === question.level - 1);
        const parentAnswer = allAnswers[_.camelCase(getLastQuestion.fieldName)];

        return _.includes(getLastQuestion.condition, parentAnswer) && this.checkChildVisibility(getLastQuestion, parentQuestion);
      }
      return false;
    },
    checkVisibility(q) {
      const check = this.visibleQuestions.some((v) => v._id === q._id);
      if (check) {
        if (q.type === 3) {
          this.isType3 = true;
        }
      } else if (!check) {
        if (q.type === 3) {
          this.regoQsAnswers[q.metaField] = [];
          this.isType3 = false;
        } else {
          this.$set(this.regoQsAnswers, q.metaField, undefined);
        }
      }

      return this.visibleQuestions.some((v) => v._id === q._id && !q.isParentQs);
    },
    clearAnswer() {
      this.$emit('closeDialog', true);
      // this.value.filtersVisible = false;
    },
    showQuestionMessage() {
      this.$alert('Additional Question details that will be retrieve', 'Question List', {
        confirmButtonText: 'OK'
      });
    },
    saveAnswer() {
      this.$refs.form.validate((valid) => {
        const verifyUpload = this.verifyUploadsAQ(this.isType3);
        if (valid && verifyUpload) {
          const regoId = this.value.registration._id;
          let isFilled = true;
          _.forEach(this.regoQsAnswers, (value, key) => {
            if (value === undefined || value === '') {
              delete this.regoQsAnswers[key];
            }
            if (key === 'ppcForm') {
              if (Object.keys(value).length > 0) {
                isFilled = _.some(Object.keys(value), (k) => value[k] !== '');
              }
            }
          });
          if (!isFilled) {
            return this.$message.error('Please fill in the PPC form');
          }
          const oldPPC = this.value.registration.meta.ppcForm;
          const newPPC = this.regoQsAnswers.ppcForm;
          const isSame = _.isEqual(oldPPC, newPPC);
          const PPCEdited = !isSame;
          let PPCUploadedIds = [];
          if (!isSame) {
            PPCUploadedIds = _.filter((_.get(this, 'value.registration.fileUploads')), (f) => f.meta.additionalQuestion === 'PPC Form').map((f) => f._id);
          }
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.put(`assemble/api/v1/portal/registrations/${this.value.row._id}/update-answer/saleable-item/${this.value.registration._id}`, {
            productType: this.value.entityType, // indv(include indv and indv-to-team) or team
            entityType: this.value.row.entityType,
            additionalQs: this.additionalQs,
            meta: this.regoQsAnswers,
            PPCEdited,
            PPCUploadedIds
          }).then((res) => {
            this.$message.success('Successful');
            this.value.filtersVisible = false;
            this.$emit('updateMeta', { meta: res.data.data.meta, regoId });
            this.$store.commit('loading', false);
          }).catch((error) => {
            this.$message.error(error.response.data.message);

            this.$store.commit('loading', false);
          });
        }
        return true;
      });
    },
    verifyUploadsAQ() {
      const mandatory = this.value.registration.additionalQs.filter((q) => q.type === 3 && q.required);
      if (mandatory.length) {
        const invalid = mandatory.filter((q) => {
          const fieldName = _.camelCase(q.fieldName);
          if (!this.regoQsAnswers[fieldName]) {
            return true;
          }
          if (this.regoQsAnswers[fieldName].length === 0) {
            return true;
          }

          return (this.regoQsAnswers[fieldName] && this.regoQsAnswers[fieldName].uploaded === false);
        });
        if (invalid.length) {
          this.$message.error(`You need to complete the following file upload(s): ${invalid.map((f) => f.question)}`);
          return false;
        }
      }
      return true;
    },
  },
  computed: {
    endOfYear() {
      return this.$store.getters['national/endOfYear'];
    },
    visibleQuestions() {
      const allQuestions = this.additionalQs;
      const allAnswers = this.regoQsAnswers;
      return allQuestions.filter((q) => {
        const { parentsQsList, isDependentQs } = q;
        if (!isDependentQs) return true;
        return parentsQsList.some((parent) => {
          const parentQ = allQuestions.find((qs) => qs._id === parent._id);
          if (!parentQ) return false;
          if (!allAnswers) return false;
          const parentAnswer = allAnswers[parentQ.metaField] || '';
          return _.includes(parent.condition, parentAnswer);
        });
      });
    },
  },
  filters: {
    metaProp(val) {
      return `${val}`;
    }
  },
  watch: {
    // eslint-disable-next-line
    'value': {
      deep: true,
      handler(val) {
        if (val.registration) {
          this.generateAQs(val);
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
 ::v-deep .el-form {
  width: 100% !important;
 }
</style>
